module.exports = __webpack_public_path__ + "/images/logo-shein.21a1a5b.webp";